import { CanDeactivateFn } from '@angular/router';

export interface CanComponentDeactivate {
    canDeactivate: () => boolean | Promise<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
    if (component.canDeactivate()) {
        return true;
    }

    return confirm(
        'You have unsaved changes. Are you sure you want to leave this page? All unsaved changes will be lost.',
    );
};
